import { CommandBase } from "../CommandBase.js";

// Handles the 'about' and 'whoami' commands
export class AboutCommand extends CommandBase {
    async execute(args) {
        this.write(`\n${this.contentManager.getBio()}\n`);
        this.write("Core Skills:", "text-accent");
        this.contentManager.getSkills().forEach(skill => {
            this.write(`  - ${skill}`);
        });
        this.write('\n');
    }
}

// Handles the 'contact' command
export class ContactCommand extends CommandBase {
    async execute(args) {
        const contact = this.contentManager.getContact();
        this.write("Contact Channels:", "text-accent");
        this.write(`  Email:    ${contact.email}`);
        this.write(`  GitHub:   ${contact.github}`);
        this.write(`  LinkedIn: ${contact.linkedin}`);
        this.write('\n');
    }
}